import api from "./api";

const route = "/pages";

export default {
  getSinglePage: (slug) => api.get(`${route}/${slug}`),
};
